import { dropdownName } from "../../utils/common";

function pickString(row, keys) {
  if (!row) return null;
  for (const key of keys) {
    const v = row[key];
    if (v != null && typeof v === "string" && v.trim()) return v.trim();
  }
  return null;
}

function nameFromEmployeeObject(emp) {
  if (!emp || typeof emp !== "object") return null;
  const fromParts = dropdownName(emp);
  if (fromParts && fromParts.trim()) return fromParts.trim();
  return (
    pickString(emp, ["name", "full_name", "fullName", "employee_name"]) || null
  );
}

function resolveById(employeeById, id) {
  if (id == null || id === "" || !employeeById) return null;
  const emp = employeeById[String(id)];
  return emp ? nameFromEmployeeObject(emp) : null;
}

/** Employee who receives the appreciation. */
export function getAppreciationToName(row, employeeById = null) {
  const nested =
    row?.toEmployee || row?.to_employee || row?.recipient || row?.recipientEmployee;
  return (
    pickString(row, [
      "toEmployeeName",
      "to_employee_name",
      "toName",
      "to_name",
      "recipientName",
      "recipient_name",
    ]) ||
    nameFromEmployeeObject(nested) ||
    resolveById(employeeById, row?.toEmployeeId ?? row?.to_employee_id) ||
    null
  );
}

/** Employee who the appreciation is from (author). */
export function getAppreciationFromName(row, employeeById = null) {
  const nested =
    row?.fromEmployee || row?.from_employee || row?.author || row?.authorEmployee;
  return (
    pickString(row, [
      "fromEmployeeName",
      "from_employee_name",
      "fromName",
      "from_name",
      "authorName",
      "author_name",
    ]) ||
    nameFromEmployeeObject(nested) ||
    resolveById(
      employeeById,
      row?.fromEmployeeId ?? row?.from_employee_id ?? row?.authorId ?? row?.author_id,
    ) ||
    null
  );
}

export function formatAppreciationParties(row, employeeById = null) {
  const to = getAppreciationToName(row, employeeById);
  const from = getAppreciationFromName(row, employeeById);
  return `To: ${to || "—"} · From: ${from || "—"}`;
}

export function buildEmployeeByIdMap(activeEmployees = []) {
  const map = {};
  (activeEmployees || []).forEach((emp) => {
    const id = emp?.employee_id ?? emp?.employeeID ?? emp?._id ?? emp?.id;
    if (id != null && id !== "") map[String(id)] = emp;
  });
  return map;
}
